import React, { useEffect, useState } from 'react';
import './Hero.css';
import { Link } from 'react-router-dom';

const ROTATION_VISIBLE_MS = 6000;
const ROTATION_TRANSITION_MS = 500;

const rotatingTexts = [
  'Competing in the FIRST Robotics Competition from Kemerburgaz Bahcesehir Science and Technology High School in Istanbul, Turkiye.',
  'Building STEM infrastructure through a UAV curriculum available in 3,561 schools nationwide.',
  'Expanding FIRST across 5 continents through team creation, mentorship, and global support.',
  'Rebuilding STEM access after earthquakes through SPINTEGRA, NASA Space Apps, and field outreach.',
  'Secured $289K in university scholarships for FIRST students.',
  'Delivered $2.3M in SolidWorks license value, resulting in 201 CSWA and 42 CSWP credentials.',
  "Built a $490K Master's pathway funding Education Technologies degrees for 35 educators.",
];

const releaseTimerHandle = (timerId) => {
  if (timerId && typeof timerId.unref === 'function') {
    timerId.unref();
  }
};

function Hero() {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    let transitionTimeoutId = null;

    const intervalId = window.setInterval(() => {
      setIsVisible(false);

      transitionTimeoutId = window.setTimeout(() => {
        setCurrentTextIndex((prevIndex) => (prevIndex + 1) % rotatingTexts.length);
        setIsVisible(true);
      }, ROTATION_TRANSITION_MS);
      releaseTimerHandle(transitionTimeoutId);
    }, ROTATION_VISIBLE_MS);
    releaseTimerHandle(intervalId);

    return () => {
      window.clearInterval(intervalId);
      if (transitionTimeoutId) {
        window.clearTimeout(transitionTimeoutId);
      }
    };
  }, []);

  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero-content">
        <h1 id="hero-title">INTEGRA 3646</h1>

        <p className={`hero-rotating-text ${isVisible ? 'visible' : ''}`} aria-live="polite">
          {rotatingTexts[currentTextIndex]}
        </p>

        <div className="hero-actions" aria-label="Primary actions">
          <Link to="/projects" className="hero-button hero-button-primary">Explore Projects</Link>
          <Link to="/about" className="hero-button hero-button-secondary">About Us</Link>
        </div>
      </div>
    </section>
  );
}

export default Hero;
